import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Form,
  message,
  Modal,
  Row,
  Input,
  Select,
  Empty,
} from "antd";
import {
  CheckOutlined,
  GlobalOutlined,
  QuestionCircleOutlined,
  YoutubeOutlined,
  DeleteOutlined,
  EditOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { useHistory, useParams, Prompt } from "react-router-dom";
import { buildPoliciesUri } from "utils/routes";
import { useFetchConstant } from "apis/constant";
import ClickableTextButton from "components/ClickableTextButton/ClickableTextButton";
import Title from "components/Title/Title";
import renderHTML from "react-render-html";
import moment from "moment";

import BraftEditor from "braft-editor";
import { ContentUtils } from "braft-utils";
import "braft-editor/dist/index.css";
import table from "braft-extensions/dist/table";
// import "braft-extensions/dist/table.css";
import Uploader from "../../../../components/Upload/Upload.Dragger";
import "./tableStyle.css";
import {
  postCreatePolicy,
  deletePolicyLibrary,
  PatchPolicyLibrary,
  revertPolicyLibrary,
  getPolicyLibraryDetails,
} from "../../../../apis/policyLibrary";
import { getUserAuthObj } from "../../../../utils/auth";
import Locale from "react-intl-universal";

const { Option } = Select;

var youtube_embed_code_buffer = "";
const Policy = () => {
  BraftEditor.use(
    table({
      includeEditors: ["editors"],
      defaultColumns: 2,
      defaultRows: 3,
      // withDropdown: true,
      columnResizable: true,
      exportAttrString:
        'border="1" style="border-collapse: collapse;width: 100%;"',
    })
  );

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [readOnlyMode, setReadOnlyMode] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [editorState, setEditorState] = useState(
    BraftEditor.createEditorState(null)
  );
  const [uploadedFile, setUploadedFile] = useState([]);
  const [saveReminder, setSaveReminder] = useState(false);
  const [youtube_embed_code, setYoutubeEmbedCode] = useState("");
  const { selection: productTypeList } = useFetchConstant("productType");
  const { selection: companyList } = useFetchConstant("insuranceCompanies");
  const { selection: groupList } = useFetchConstant("group");
  const { selection: riderList } = useFetchConstant("riderType");
  const [logList, setLogList] = useState([]);
  console.log(companyList, 80);
  const { id } = useParams();
  const history = useHistory();

  const jwt = getUserAuthObj();

  // console.log(useFetchConstant("group"));
  // console.log(useParams().id);

  useEffect(() => {
    if (id) {
      GetPolicyLibraryDetails(id);
    } else {
      form.setFieldsValue({
        links: [
          {
            item: "",
            link: "",
          },
        ],
      });
    }
  }, []);

  useEffect(() => {
    console.log(form.isFieldTouched(), 105);
    setSaveReminder(true);
  }, [form.isFieldTouched()]);

  const GetPolicyLibraryDetails = async (id) => {
    setLoading(true);
    const res = await getPolicyLibraryDetails(id);
    console.log(res);

    form.setFieldsValue({
      product_name: res.product_name,
      product_code: res.product_code,
      company: res.company,
      group: res.group,
      product_type: res.product_type,
      rider_type: res.rider_type,
      product_overview: res.product_overview,
      links: res.links,
    });
    setUploadedFile(res.attachment ? res.attachment : []);
    setReadOnlyMode(true);
    setLogList(res.logs);

    setEditorState(BraftEditor.createEditorState(res.raw));

    setHtmlContent(res.html);
    // setEditorState(BraftEditor.createEditorState(policyDetails.htmlContent));

    setLoading(false);

    // form.setFieldsValue({
    //   product_name: "Elden Ring",
    //   product_code: "ER95",
    //   company: "Bandai Entertainment",
    //   group: "Agency Club",
    //   product_type: "Investment - Linked Plan",
    //   rider_type: "RGB",
    //   product_overview:
    //     "Elden Ring is an expansive fantasy Action-RPG game developed by FromSoftware, Inc. under the direction of Hidetaka Miyazaki and created in collaboration with famed author George R.R. Martin.",
    //   product_description:
    //     "Elden Ring takes place in the realm of the Lands Between, sometime after the destruction of the titular Elden Ring and the scattering of its shards, the Great Runes. Once graced by the Ring and the Erdtree which symbolizes its presence, the realm is now ruled over by the demigod offspring of Queen Marika the Eternal, each possessing a shard of the Ring that corrupts and taints them with power. As Tarnished — exiles from the Lands Between who lost the Ring's grace and are summoned back after the Shattering — players must traverse the realm to ultimately find all the Great Runes, restore the Elden Ring, and become the Elden Lord.",
    //   links: [
    //     {
    //       item: "Elden Ring",
    //       link: "https://eldenring.bn-ent.net/en/",
    //     },
    //   ],
    // });

    // setData(res);
    // if (res.status === 200) {
    //   setLoading(false);

    //   setData(res);
    // } else {
    //   setLoading(false);
    // }
  };

  const handleUploadedTemplate = async (value) => {
    /* 
Flow
1. Check is file valid
2. Parse excel file
3. Check parsed file format
4. Compose data
5. Check value
 */
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      md: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      md: { span: 24 },
    },
  };

  const onFinish = async () => {
    try {
      const values = await form.validateFields();

      values.product_description = editorState.toHTML();
      values.html = editorState.toHTML();
      values.raw = editorState.toRAW();
      values.attachment = uploadedFile;
      console.log(values);
      setLoading(true);

      try {
        if (id) {
          /// Modify
          const res = await PatchPolicyLibrary(id, values);
          console.log(res);
          setLoading(false);
          Modal.success({
            title: Locale.get("addNewPolicy.modifySuccess"),
            onOk: () => {
              history.push(buildPoliciesUri());

              window.location.reload();
            },
          });
        } else {
          /// Create
          const res = await postCreatePolicy(values);
          console.log(res);

          Modal.success({
            title: Locale.get("addNewPolicy.createSuccess"),
            onOk: () => {
              history.push(buildPoliciesUri());

              window.location.reload();
            },
          });
          setLoading(false);
        }
      } catch (error) {
        message.error(error.message);
        setLoading(false);
      }
      // const res = await PatchPolicyLibrary("62239e8eb2f5ef0ed71624aa", values);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleDeletePolicyLibrary = async () => {
    const res = await deletePolicyLibrary(id);
    console.log(res);

    Modal.success({
      title: Locale.get("addNewPolicy.deletePolicy"),
      onOk: () => {
        history.push(buildPoliciesUri());

        window.location.reload();
      },
    });
  };

  const handleRevertPolicyLibrary = async (_id) => {
    console.log(_id);

    const res = await revertPolicyLibrary({
      id: id,
      revert_id: _id,
    });
    console.log(res);
    Modal.success({
      title: Locale.get("addNewPolicy.deletePolicy"),
      onOk: () => {
        // history.push(buildPoliciesUri());
        window.location.reload();
      },
    });
  };

  const handleDeleteAttachment = (index) => () => {
    var buffer = [...uploadedFile];
    buffer = buffer.filter((x, i) => i !== index);
    setUploadedFile(buffer);
    setSaveReminder(true);
  };

  const AddEmbedded = () => {
    setEditorState(
      ContentUtils.insertMedias(editorState, [
        {
          type: "EMBED",
          url: youtube_embed_code_buffer,
        },
      ])
    );
  };

  const preview = () => {
    if (window.previewWindow) {
      window.previewWindow.close();
    }

    window.previewWindow = window.open();
    window.previewWindow.document.write(buildPreviewHtml());
    window.previewWindow.document.close();
  };

  // const uploadPDFHandler = async callback => {
  //   console.log(callback);
  //   message.loading("Uploading...");
  //   if (callback.file.status === "done") {
  //     message.destroy();
  //     message.success("Upload successful");
  //     if (callback.file.response.length > 0) {
  //       const url = callback.file.response[0].url;

  //       setEditorState(
  //         ContentUtils.insertMedias(editorState, [
  //           {
  //             type: "EMBED",
  //             // url: `<embed src="${url}" width="100%" height="800px !important" />`
  //             url: `<object class="pdf-render" data="${url}" type="application/pdf" width="100%" height="800px !important">
  //            <div class="align-center"><p >Your web browser doesn't have a PDF plugin.
  //             Instead you can <a href="${url}" target="_blank" style="color: #0000cd; ">click here to
  //             download the PDF file.</a></p>             </div>
  //           </object>

  //           <div class="pdf-render-show"><p >Mobile browser doesn't support PDF viewer.
  //             Instead you can <a href="${url}" target="_blank" style="color: #0000cd; ">click here to
  //             view / download the PDF file.</a></p>             </div> `
  //           }
  //         ])
  //       );
  //     }
  //   }
  // };

  const buildPreviewHtml = () => {
    return `
      <!Doctype html>
      <html>
        <head>
          <title>Preview Content</title>
          <style>
            html,body{
              height: 100%;
              margin: 0;
              padding: 0;
              overflow: auto;
              background-color: #f1f2f3;
            }
            .container{
              box-sizing: border-box;
              width: 70%;
              max-width: 100%;
              min-height: 100%;
              margin: 0 auto;
              padding: 30px 20px;
              overflow: hidden;
              background-color: #fff;
              border-right: solid 1px #eee;
              border-left: solid 1px #eee;
            }
            .container img,
            .container audio,
            .container video{
              max-width: 100%;
               height: auto;
             }
             .container iframe{
               max-width: 100%;
               height: 568px;
             }
             .container p{
               white-space: pre-wrap;
               min-height: 1em;
             }
             .container pre{
               padding: 15px;
               background-color: #f1f1f1;
               border-radius: 5px;
             }
             .container blockquote{
               margin: 0;
               padding: 15px;
               background-color: #f1f1f1;
               border-left: 3px solid #d1d1d1;
             }
           </style>
         </head>
         <body>
           <div class="container">${editorState.toHTML()}</div>
         </body>
       </html>
     `;
  };

  const controls = [
    "undo",
    "redo",
    "separator",
    "font-size",
    "line-height",
    "letter-spacing",
    "separator",
    "text-color",
    "bold",
    "italic",
    "underline",
    "strike-through",
    "separator",
    "superscript",
    "subscript",
    "remove-styles",
    "separator",
    "emoji",
    "media",
    "separator",
    "text-indent",
    "text-align",
    "separator",
    "headings",
    "list-ul",
    "list-ol",
    "separator",
    "link",
    "separator",
    "hr",
    "separator",
    "clear",
  ];

  const extendControls = [
    // {
    //   key: "antd-uploader",
    //   type: "component",
    //   component: (
    //     <Upload
    //       accept="image/*"
    //       showUploadList={false}
    //       beforeUpload={beforeUpload}
    //       onChange={uploadHandler}
    //       // {...campaignApi.upload_content_image()}
    //     >
    //       {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
    //       <button
    //         type="button"
    //         className="control-item button upload-button"
    //         data-title="插入图片"
    //       >
    //         {/* <Icon type="paper-clip" /> */}
    //         <PaperClipOutlined />
    //       </button>
    //     </Upload>
    //   )
    // },
    {
      key: "custom-button",
      type: "button",
      text: "Preview",
      onClick: preview,
    },
    "separator",
    {
      key: "my-modal",
      type: "modal",
      // text: <Icon type="youtube" />,
      text: <YoutubeOutlined />,
      onClick: () => {},
      modal: {
        id: "my-modal-1", // 必选属性，传入一个唯一字符串即可
        title: "Embed External Media", // 指定弹窗组件的顶部标题
        className: "my-modal", // 指定弹窗组件样式名
        width: 300, // 指定弹窗组件的宽度
        height: 250, // 指定弹窗组件的高度
        showFooter: true, // 指定是否显示弹窗组件底栏
        showCancel: true, // 指定是否显示取消按钮
        showConfirm: true, // 指定是否显示确认按钮
        confirmable: true, // 指定确认按钮是否可用
        showClose: true, // 指定是否显示右上角关闭按钮
        closeOnBlur: true, // 指定是否在点击蒙层后关闭弹窗(v2.1.24)
        closeOnConfirm: true, // 指定是否在点击确认按钮后关闭弹窗(v2.1.26)
        closeOnCancel: true, // 指定是否在点击取消按钮后关闭弹窗(v2.1.26)
        cancelText: Locale.get("addNewPolicy.cancel"), // 指定取消按钮文字
        confirmText: Locale.get("addNewPolicy.ok"), // 指定确认按钮文字
        bottomText: null, // 指定弹窗组件底栏左侧的文字，可传入jsx

        onConfirm: () => AddEmbedded(), // 指定点击确认按钮后的回调函数
        onCancel: () => {}, // 指定点击取消按钮后的回调函数
        onClose: () => {}, // 指定弹窗被关闭后的回调函数
        onBlur: () => {}, // 指定蒙层被点击时的回调函数
        children: (
          <div style={{ padding: 16 }}>
            <a
              href="https://support.google.com/youtube/answer/171780?hl=en"
              target="_blank"
              style={{ color: "#385898" }}
            >
              <QuestionCircleOutlined style={{ paddingRight: 4 }} />
              How to get Youtube Embedd Code
            </a>
            <br />
            <br />
            Embed Code :
            <Input
              autoFocus
              style={{ marginTop: 8 }}
              onChange={(e) => {
                youtube_embed_code_buffer = e.target.value;
              }}
            />
          </div>
        ), // 指定弹窗组件的内容组件
      },
    },
    "separator",
    // {
    //   key: "instagram-modal",
    //   type: "modal",
    //   // text: <Icon type="instagram" />,
    //   text: <InstagramOutlined />,
    //   onClick: () => {},
    //   modal: {
    //     id: "my-modal", // 必选属性，传入一个唯一字符串即可
    //     title: "Embed External Media", // 指定弹窗组件的顶部标题
    //     className: "my-modal", // 指定弹窗组件样式名
    //     width: 300, // 指定弹窗组件的宽度
    //     height: 250, // 指定弹窗组件的高度
    //     showFooter: true, // 指定是否显示弹窗组件底栏
    //     showCancel: true, // 指定是否显示取消按钮
    //     showConfirm: true, // 指定是否显示确认按钮
    //     confirmable: true, // 指定确认按钮是否可用
    //     showClose: true, // 指定是否显示右上角关闭按钮
    //     closeOnBlur: true, // 指定是否在点击蒙层后关闭弹窗(v2.1.24)
    //     closeOnConfirm: true, // 指定是否在点击确认按钮后关闭弹窗(v2.1.26)
    //     closeOnCancel: true, // 指定是否在点击取消按钮后关闭弹窗(v2.1.26)
    //     cancelText: "Cancel", // 指定取消按钮文字
    //     confirmText: "Confirm", // 指定确认按钮文字
    //     bottomText: null, // 指定弹窗组件底栏左侧的文字，可传入jsx

    //     onConfirm: () => AddEmbedded(), // 指定点击确认按钮后的回调函数
    //     onCancel: () => {}, // 指定点击取消按钮后的回调函数
    //     onClose: () => {}, // 指定弹窗被关闭后的回调函数
    //     onBlur: () => {}, // 指定蒙层被点击时的回调函数
    //     children: (
    //       <div style={{ padding: 16 }}>
    //         Embed Code :
    //         <Input
    //           autoFocus
    //           style={{ marginTop: 8 }}
    //           onChange={e => setYoutubeEmbedCode(e.target.value)}
    //         />
    //       </div>
    //     ) // 指定弹窗组件的内容组件
    //   }
    // },
    // "separator",
    // {
    //   key: "facebook-modal",
    //   type: "modal",
    //   // text: <Icon type="facebook" />,
    //   text: <FacebookOutlined />,
    //   onClick: () => {},
    //   modal: {
    //     id: "my-modal", // 必选属性，传入一个唯一字符串即可
    //     title: "Embed External Media", // 指定弹窗组件的顶部标题
    //     className: "my-modal", // 指定弹窗组件样式名
    //     width: 300, // 指定弹窗组件的宽度
    //     height: 250, // 指定弹窗组件的高度
    //     showFooter: true, // 指定是否显示弹窗组件底栏
    //     showCancel: true, // 指定是否显示取消按钮
    //     showConfirm: true, // 指定是否显示确认按钮
    //     confirmable: true, // 指定确认按钮是否可用
    //     showClose: true, // 指定是否显示右上角关闭按钮
    //     closeOnBlur: true, // 指定是否在点击蒙层后关闭弹窗(v2.1.24)
    //     closeOnConfirm: true, // 指定是否在点击确认按钮后关闭弹窗(v2.1.26)
    //     closeOnCancel: true, // 指定是否在点击取消按钮后关闭弹窗(v2.1.26)
    //     cancelText: "Cancel", // 指定取消按钮文字
    //     confirmText: "Confirm", // 指定确认按钮文字
    //     bottomText: null, // 指定弹窗组件底栏左侧的文字，可传入jsx

    //     onConfirm: () => AddEmbedded(), // 指定点击确认按钮后的回调函数
    //     onCancel: () => {}, // 指定点击取消按钮后的回调函数
    //     onClose: () => {}, // 指定弹窗被关闭后的回调函数
    //     onBlur: () => {}, // 指定蒙层被点击时的回调函数
    //     children: (
    //       <div style={{ padding: 16 }}>
    //         <a
    //           href="https://developers.facebook.com/docs/plugins/embedded-posts"
    //           target="_blank"
    //           style={{ color: "#385898" }}
    //         >
    //           <QuestionCircleOutlined style={{ paddingRight: 4 }} />
    //           How to get Facebook Embedd Code
    //         </a>
    //         <br />
    //         <br />
    //         Embed Code :
    //         <Input
    //           autoFocus
    //           style={{ marginTop: 8 }}
    //           onChange={e => setYoutubeEmbedCode(e.target.value)}
    //         />
    //       </div>
    //     ) // 指定弹窗组件的内容组件
    //   }
    // },
    // "separator",
    // {
    //   key: "pdf-uploader",
    //   type: "component",
    //   component: (
    //     <Upload
    //       accept="application/pdf"
    //       showUploadList={false}
    //       // beforeUpload={this.beforeUploadPDF}
    //       onChange={uploadPDFHandler}
    //       // {...NewAndEventMgmtApi.upload_content_pdf(this.state.content_number)}
    //     >
    //       {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
    //       <button
    //         type="button"
    //         className="control-item button upload-button"
    //         data-title="Insert PDF"
    //       >
    //         {/* <Icon type="paper-clip" /> */}
    //         <FilePdfOutlined />
    //       </button>
    //     </Upload>
    //   )
    // },
    {
      key: "html-modal",
      type: "modal",
      // text: <Icon type="facebook" />,
      text: (
        <span>
          <GlobalOutlined /> HTML
        </span>
      ),
      onClick: () => {},
      modal: {
        id: "my-modal", // 必选属性，传入一个唯一字符串即可
        title: "Embed HTML", // 指定弹窗组件的顶部标题
        className: "my-modal", // 指定弹窗组件样式名
        width: 300, // 指定弹窗组件的宽度
        height: 320, // 指定弹窗组件的高度
        showFooter: true, // 指定是否显示弹窗组件底栏
        showCancel: true, // 指定是否显示取消按钮
        showConfirm: true, // 指定是否显示确认按钮
        confirmable: true, // 指定确认按钮是否可用
        showClose: true, // 指定是否显示右上角关闭按钮
        closeOnBlur: true, // 指定是否在点击蒙层后关闭弹窗(v2.1.24)
        closeOnConfirm: true, // 指定是否在点击确认按钮后关闭弹窗(v2.1.26)
        closeOnCancel: true, // 指定是否在点击取消按钮后关闭弹窗(v2.1.26)
        cancelText: Locale.get("addNewPolicy.cancel"), // 指定取消按钮文字
        confirmText: Locale.get("addNewPolicy.ok"), // 指定确认按钮文字
        bottomText: null, // 指定弹窗组件底栏左侧的文字，可传入jsx

        onConfirm: () => AddEmbedded(), // 指定点击确认按钮后的回调函数
        onCancel: () => {}, // 指定点击取消按钮后的回调函数
        onClose: () => {}, // 指定弹窗被关闭后的回调函数
        onBlur: () => {}, // 指定蒙层被点击时的回调函数
        children: (
          <div style={{ padding: 16 }}>
            Embed HTML :
            <Input.TextArea
              autoFocus
              style={{ marginTop: 8 }}
              autoSize={{ minRows: 5, maxRows: 5 }}
              onChange={(e) => {
                youtube_embed_code_buffer = e.target.value;
              }}
            />
          </div>
        ), // 指定弹窗组件的内容组件
      },
    },
  ];

  const myValidateFn = (file) => {
    console.log(file);
    return new Promise((resolve, reject) => {
      //Limit img file size to max 3MB
      if (file.size < 3096 * 1000) {
        resolve();
      } else {
        message.error("File size too exceed 3MB");
        reject();
      }
    });
  };

  const printChangeParameter = (different) => {
    var buffer = [];

    for (const key in different) {
      if (different.hasOwnProperty(key)) {
        buffer.push(key);
      }
    }

    return buffer.toString();
  };

  return (
    <div>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Row>
            <ClickableTextButton
              text={Locale.get("addNewPolicy.backToViewAll")}
              onClick={() => history.push(buildPoliciesUri())}
              type="back"
              showIcon={true}
            />
          </Row>

          <Row>
            <Title>{Locale.get("addNewPolicy.pageTitle")}</Title>
          </Row>
        </Col>

        <Col>
          <Row align="middle" gutter={16}>
            {(id && jwt.role === "admin") ||
            (id && jwt.role === "contributor") ||
            (id && jwt.role === "agent_full_and_contributor") ? (
              <Col>
                <Button
                  style={{ color: "red", borderColor: "red" }}
                  icon={<DeleteOutlined />}
                  onClick={() =>
                    Modal.confirm({
                      title: "Confirm to delete?",
                      onOk: () => {
                        handleDeletePolicyLibrary();
                      },
                    })
                  }
                  loading={loading}
                >
                  {Locale.get("addNewPolicy.delete")}
                </Button>
              </Col>
            ) : null}
            {(id && jwt.role === "admin") ||
            (id && jwt.role === "contributor") ||
            (id && jwt.role === "agent_full_and_contributor") ? (
              <Col>
                <Button
                  style={{ color: "#e3ba24", borderColor: "#e3ba24" }}
                  icon={<EditOutlined />}
                  onClick={() => setReadOnlyMode(!readOnlyMode)}
                  loading={loading}
                >
                  {readOnlyMode
                    ? Locale.get("addNewPolicy.modify")
                    : Locale.get("addNewPolicy.cancelModify")}
                </Button>
              </Col>
            ) : null}
            {(id && jwt.role === "admin" && !readOnlyMode) ||
            (id &&
              (jwt.role === "contributor" ||
                jwt.role === "agent_full_and_contributor") &&
              !readOnlyMode) ? (
              <Col>
                <Button
                  type="primary"
                  icon={<CheckOutlined />}
                  onClick={onFinish}
                  loading={loading}
                >
                  {Locale.get("addNewPolicy.saveButton")}
                </Button>
              </Col>
            ) : (!id && jwt.role === "admin") ||
              (!id &&
                (jwt.role === "contributor" ||
                  jwt.role === "agent_full_and_contributor")) ? (
              <Col>
                <Button
                  type="primary"
                  icon={<CheckOutlined />}
                  onClick={onFinish}
                  loading={loading}
                >
                  {Locale.get("addNewPolicy.saveButton")}
                </Button>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>

      <Form
        name="login"
        form={form}
        layout="vertical"
        onFinish={onFinish}
        {...formItemLayout}
        hideRequiredMark
      >
        <div style={{ border: "1px solid rgba(0,0,0,0.15)", marginBottom: 24 }}>
          <Row>
            <Col>
              <div
                style={{
                  padding: "8px 16px",
                  margin: "24px 0px 24px 0px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: 800,
                  fontSize: 16,
                  borderRadius: "0px 4px 4px 0px",
                  color: "#000000",
                }}
              >
                {Locale.get("addNewPolicy.formTitle_0")}
              </div>
            </Col>
          </Row>

          <div style={{ padding: 24 }}>
            <Row justify="space-between">
              <Col span={11}>
                <Form.Item
                  name="product_name"
                  label={
                    <span
                      style={{
                        fontWeight: 500,
                        fontSize: 18,
                        color: "rgba(0,0,0,0.65)",
                      }}
                    >
                      {Locale.get("addNewPolicy.productName")}
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: Locale.get("addNewPolicy.errMsgProductName"),
                    },
                  ]}
                >
                  <Input disabled={loading} readOnly={readOnlyMode} />
                </Form.Item>
              </Col>

              <Col offset={2} span={11}>
                <Form.Item
                  name="product_code"
                  label={
                    <span
                      style={{
                        fontWeight: 500,
                        fontSize: 18,
                        color: "rgba(0,0,0,0.65)",
                      }}
                    >
                      {Locale.get("addNewPolicy.productCode")}
                    </span>
                  }
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Product Code is required",
                  //   },
                  // ]}
                >
                  <Input disabled={loading} readOnly={readOnlyMode} />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="space-between">
              <Col span={11}>
                <Form.Item
                  name="company"
                  label={
                    <span
                      style={{
                        fontWeight: 500,
                        fontSize: 18,
                        color: "rgba(0,0,0,0.65)",
                      }}
                    >
                      {Locale.get("addNewPolicy.companyName")}
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: Locale.get("addNewPolicy.errMsgCompanyName"),
                    },
                  ]}
                >
                  <Select
                    disabled={loading || readOnlyMode}
                    style={{ width: "100%" }}
                    showSearch
                  >
                    <Option key={"-"} value={"-"}>
                      {"-"}
                    </Option>
                    {companyList.map((value) => (
                      <Option key={value.code} value={value.code}>
                        {value.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col offset={2} span={11}>
                <Form.Item
                  name="group"
                  label={
                    <span
                      style={{
                        fontWeight: 500,
                        fontSize: 18,
                        color: "rgba(0,0,0,0.65)",
                      }}
                    >
                      {Locale.get("addNewPolicy.group")}
                    </span>
                  }
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Group is required",
                  //   },
                  // ]}
                >
                  <Select
                    // defaultValue="lucy"
                    disabled={loading || readOnlyMode}
                    style={{ width: "100%" }}
                    onChange={(e) => console.log(e)}
                  >
                    <Option key={"-"} value={"-"}>
                      {"-"}
                    </Option>
                    {groupList.map((value) => (
                      <Option key={value.value} value={value.value}>
                        {value.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row justify="space-between">
              <Col span={11}>
                <Form.Item
                  name="product_type"
                  label={
                    <span
                      style={{
                        fontWeight: 500,
                        fontSize: 18,
                        color: "rgba(0,0,0,0.65)",
                      }}
                    >
                      {Locale.get("addNewPolicy.productType")}
                    </span>
                  }
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Product Type is required",
                  //   },
                  // ]}
                >
                  <Select
                    // defaultValue="lucy"
                    disabled={loading || readOnlyMode}
                    style={{ width: "100%" }}
                    onChange={(e) => console.log(e)}
                  >
                    <Option key={"-"} value={"-"}>
                      {"-"}
                    </Option>
                    {productTypeList.map((value) => (
                      <Option key={value.value} value={value.value}>
                        {value.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col offset={2} span={11}>
                <Form.Item
                  name="rider_type"
                  label={
                    <span
                      style={{
                        fontWeight: 500,
                        fontSize: 18,
                        color: "rgba(0,0,0,0.65)",
                      }}
                    >
                      {Locale.get("addNewPolicy.riderType")}
                    </span>
                  }
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Rider Type is required",
                  //   },
                  // ]}
                >
                  <Select
                    // defaultValue="lucy"
                    disabled={loading || readOnlyMode}
                    style={{ width: "100%" }}
                    onChange={(e) => console.log(e)}
                  >
                    <Option key={"-"} value={"-"}>
                      {"-"}
                    </Option>
                    {riderList.map((value) => (
                      <Option key={value.value} value={value.value}>
                        {value.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>

        <div style={{ border: "1px solid rgba(0,0,0,0.15)", marginBottom: 24 }}>
          <Row>
            <Col>
              <div
                style={{
                  padding: "8px 16px",
                  margin: "24px 0px 24px 0px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: 800,
                  fontSize: 16,
                  borderRadius: "0px 4px 4px 0px",
                  color: "#000000",
                }}
              >
                {Locale.get("addNewPolicy.formTitle_1")}
              </div>
            </Col>
          </Row>

          <div style={{ padding: 24 }}>
            <Form.Item
              name="product_overview"
              label={
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: 18,
                    color: "rgba(0,0,0,0.65)",
                  }}
                >
                  {Locale.get("addNewPolicy.productOverview")}
                </span>
              }
              // rules={[
              //   {
              //     required: true,
              //     message: "Product Overview is required",
              //   },
              // ]}
            >
              <Input.TextArea
                // showCount
                // maxLength={300}
                readOnly={readOnlyMode}
                disabled={loading}
                autoSize={{ minRows: 3, maxRows: 5 }}
              />
            </Form.Item>

            <Form.Item
              label={
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: 18,
                    color: "rgba(0,0,0,0.65)",
                  }}
                >
                  {Locale.get("addNewPolicy.detailDesc")}
                </span>
              }
            >
              {readOnlyMode ? (
                <div
                  style={{
                    // height: 500,
                    // overflowY: "scroll",
                    overflowX: "auto",
                    padding: "11px 8px",
                    border: "1px solid rgba(0,0,0,0.15)",
                    borderRadius: 4,
                  }}
                  className="bf-table-container"
                >
                  {renderHTML(htmlContent)}
                </div>
              ) : (
                <BraftEditor
                  style={{
                    border: "1px solid #d9d9d9",
                    padding: 0,
                    borderRadius: 4,
                  }}
                  className="Table-Style"
                  // controls={controls}
                  extendControls={extendControls}
                  language="en"
                  id="editors"
                  media={{
                    accepts: {
                      image:
                        "image/png,image/jpeg,image/gif,image/webp,image/apng,image/svg",
                    },
                    validateFn: myValidateFn,
                  }}
                  value={editorState}
                  onChange={(editorState) => {
                    // console.log(editorState.toHTML());
                    setEditorState(editorState);
                  }}
                />
              )}
            </Form.Item>
          </div>
        </div>

        <div style={{ border: "1px solid rgba(0,0,0,0.15)", marginBottom: 24 }}>
          <Row>
            <Col>
              <div
                style={{
                  padding: "8px 16px",
                  margin: "24px 0px 24px 0px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: 800,
                  fontSize: 16,
                  borderRadius: "0px 4px 4px 0px",
                  color: "#000000",
                }}
              >
                {Locale.get("addNewPolicy.formTitle_2")}
              </div>
            </Col>
          </Row>

          <div style={{ padding: 24 }}>
            <Form.List
              name="links"
              // rules={[
              //   {
              //     validator: async (_, links) => {
              //       if (!links || links.length < 1) {
              //         return Promise.reject(new Error("At least 1 link"));
              //       }
              //     },
              //   },
              // ]}
            >
              {(fields, { add, remove }, { errors }) => (
                <>
                  {fields.map((field, name, index) => (
                    <Row>
                      <Col span={10}>
                        <Form.Item
                          name={[name, "item"]}
                          // rules={[
                          //   { required: true, message: "Item is required" },
                          // ]}
                        >
                          <Input
                            disabled={loading}
                            readOnly={readOnlyMode}
                            placeholder={Locale.get(
                              "addNewPolicy.itemPlaceholder"
                            )}
                          />
                        </Form.Item>
                      </Col>

                      <Col offset={1} span={12}>
                        <Form.Item
                          name={[name, "link"]}
                          // rules={[
                          //   { required: true, message: "Link is required" },
                          // ]}
                        >
                          <Input
                            disabled={loading}
                            readOnly={readOnlyMode}
                            placeholder={Locale.get(
                              "addNewPolicy.linkPlaceholder"
                            )}
                            onClick={() =>
                              readOnlyMode &&
                              window.open(
                                form.getFieldValue("links")[name].link
                              )
                            }
                            style={{ cursor: readOnlyMode && "pointer" }}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={1} style={{ textAlign: "end" }}>
                        {id && !readOnlyMode && fields.length > 1 ? (
                          <MinusCircleOutlined
                            style={{
                              fontSize: 18,
                              color: "red",
                              transform: "translate(0px, 11px)",
                            }}
                            onClick={() => remove(field.name)}
                          />
                        ) : (
                          !id &&
                          fields.length > 1 && (
                            <MinusCircleOutlined
                              style={{
                                fontSize: 18,
                                color: "red",
                                transform: "translate(0px, 11px)",
                              }}
                              onClick={() => remove(field.name)}
                            />
                          )
                        )}
                      </Col>
                    </Row>
                  ))}

                  {id && !readOnlyMode ? (
                    <Form.Item>
                      <Row justify="center">
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          style={{ width: "60%" }}
                          icon={<PlusOutlined />}
                        >
                          {Locale.get("addNewPolicy.addLinkButton")}
                        </Button>
                      </Row>
                    </Form.Item>
                  ) : (
                    !id && (
                      <Form.Item>
                        <Row justify="center">
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            style={{ width: "60%" }}
                            icon={<PlusOutlined />}
                          >
                            {Locale.get("addNewPolicy.addLinkButton")}
                          </Button>
                        </Row>
                      </Form.Item>
                    )
                  )}

                  <Form.ErrorList errors={errors} />
                </>
              )}
            </Form.List>
            {/* <Row>
              <Col span={10}>
                <Form.Item
                  name="item"
                  label={
                    <span
                      style={{
                        fontWeight: 500,
                        fontSize: 18,
                        color: "rgba(0,0,0,0.65)"
                      }}
                    >
                      Item
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Item is required"
                    }
                  ]}
                >
                  <Input disabled={loading} />
                </Form.Item>
              </Col>

              <Col offset={1} span={13}>
                <Form.Item
                  name="link"
                  label={
                    <span
                      style={{
                        fontWeight: 500,
                        fontSize: 18,
                        color: "rgba(0,0,0,0.65)"
                      }}
                    >
                      Link
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Link is required"
                    }
                  ]}
                >
                  <Input disabled={loading} />
                </Form.Item>
              </Col>
            </Row>
           */}
          </div>
        </div>

        <div style={{ border: "1px solid rgba(0,0,0,0.15)", marginBottom: 24 }}>
          <Row>
            <Col>
              <div
                style={{
                  padding: "8px 16px",
                  margin: "24px 0px 24px 0px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: 800,
                  fontSize: 16,
                  borderRadius: "0px 4px 4px 0px",
                  color: "#000000",
                }}
              >
                {Locale.get("addNewPolicy.formTitle_3")}
              </div>
            </Col>
          </Row>

          <div style={{ padding: 24 }}>
            {uploadedFile.length === 0 && (
              <Row justify="center">
                <Empty description={Locale.get("addNewPolicy.noAttach")} />
              </Row>
            )}
            <Row style={{ marginBottom: 16 }}>
              {uploadedFile.map((value, index) => (
                <Col span={24} key={value.uid}>
                  <Button
                    type="link"
                    href={value.url}
                    target="_blank"
                    icon={<LinkOutlined />}
                    style={{ color: "#e3ba24" }}
                  >
                    {value.name}
                  </Button>

                  {!readOnlyMode && (
                    <Button
                      style={{ color: "red", borderColor: "red" }}
                      shape="circle"
                      size="small"
                      onClick={handleDeleteAttachment(index)}
                    >
                      <DeleteOutlined />
                    </Button>
                  )}
                </Col>
              ))}
            </Row>

            {readOnlyMode === false && (
              <Uploader
                onChange={(e) => {
                  setUploadedFile([...uploadedFile, ...e]);
                  setSaveReminder(true);
                }}
                isMultiple
              />
            )}
          </div>
        </div>

        {id && jwt.role === "admin" && logList.length > 0 && (
          <div
            style={{ border: "1px solid rgba(0,0,0,0.15)", marginBottom: 24 }}
          >
            <Row>
              <Col>
                <div
                  style={{
                    padding: "8px 16px",
                    margin: "24px 0px 24px 0px",
                    backgroundColor: "#f2f2f2",
                    fontWeight: 800,
                    fontSize: 16,
                    borderRadius: "0px 4px 4px 0px",
                    color: "#000000",
                  }}
                >
                  Log
                </div>
              </Col>
            </Row>

            <div style={{ padding: 24 }}>
              <Row style={{ fontSize: 16, marginBottom: 16 }}>
                <Col span={18}>Last Change</Col>

                <Col span={6}>User</Col>
              </Row>

              {logList.map((value, index) => (
                <Row key={value._id} style={{ fontSize: 16, marginBottom: 16 }}>
                  <Col span={18}>
                    Updated ({printChangeParameter(value.different)}) on{" "}
                    {moment(value.updatedAt).format("Do MMMM YYYY hh:mm a")}{" "}
                    {!readOnlyMode && (
                      <span
                        style={{ color: "#2e89ff", cursor: "pointer" }}
                        onClick={() =>
                          Modal.confirm({
                            title: "Confirm to rever?",
                            onOk: () => handleRevertPolicyLibrary(value._id),
                          })
                        }
                      >
                        [Revert]
                      </span>
                    )}
                  </Col>

                  <Col span={6}>
                    {value.updatedBy?.firstName} {value.updatedBy?.lastName}
                  </Col>
                </Row>
              ))}
            </div>
          </div>
        )}
      </Form>
      <Prompt
        when={saveReminder}
        message={Locale.get("addNewPolicy.promptMessage")}
      />
      {/* <Row gutter={24} justify="center" align="middle">
        <Col style={{ fontSize: 18 }}>
          Something not right ? Drop us your feedback here
        </Col>

        <Col>
          <Button
            size="large"
            style={{ width: 520, backgroundColor: "#d7a301", color: "#fff" }}
          >
            Feedback Form
          </Button>
        </Col>
      </Row> */}
    </div>
  );
};

export default Policy;

// import React, { useState, useEffect, useMemo } from "react";
// import {
//   Button,
//   Checkbox,
//   Col,
//   Form,
//   message,
//   Modal,
//   Row,
//   Skeleton,
//   Table,
// } from "antd";
// import { CheckOutlined } from "@ant-design/icons";
// import { useHistory, useParams } from "react-router-dom";

// import {
//   deletePolicy,
//   postCreatePolicy,
//   patchPolicy,
//   refetchPolicies,
//   refetchPolicyDetails,
//   useGetPolicyDetails,
// } from "apis/policy";
// import { useFetchConstant } from "apis/constant";

// import { getLabelOfConstant, constructDisplayPrice } from "utils/general";
// import { buildPoliciesUri } from "utils/routes";

// import ClickableTextButton from "components/ClickableTextButton/ClickableTextButton";
// import FormInput from "components/FormInput/FormInput";
// import FormSelection from "components/FormSelection/FormSelection";
// import ScrollableContainer from "components/ScrollableContainer/ScrollableContainer";
// import SectionCard from "components/SectionCard/SectionCard";
// import SectionContainer from "components/SectionContainer/SectionContainer";
// import Title from "components/Title/Title";

// import AddCoverageBenefitModal from "../AddCoverageBenefitModal/AddCoverageBenefitModal";
// import {
//   DeleteCol,
//   DescriptionForLabel,
//   ExtraInfoText,
//   FinancialValueText,
//   Label,
// } from "./Policy.styles";

// const { useForm, Item: FormItem } = Form;
// const { confirm, success, error } = Modal;

// const BENEFIT_TYPE_PLAN_COVERAGE = "planCoverage";
// const BENEFIT_TYPE_HOSPITALIZATION = "hospitalization";
// const BENEFIT_TYPE_FEMALE = "female";

// const formatAllBenefits = (benefits) => {
//   const planCoverages =
//     (benefits.planCoverages &&
//       benefits.planCoverages.map((planCoverage) => ({
//         ...planCoverage,
//         category: BENEFIT_TYPE_PLAN_COVERAGE,
//       }))) ||
//     [];
//   const hospitalizationBenefits =
//     (benefits.hospitalizationBenefits &&
//       benefits.hospitalizationBenefits.map((hospitalizationBenefit) => ({
//         ...hospitalizationBenefit,
//         category: BENEFIT_TYPE_HOSPITALIZATION,
//       }))) ||
//     [];
//   const femaleBenefits =
//     (benefits.femaleBenefits &&
//       benefits.femaleBenefits.map((femaleBenefit) => ({
//         ...femaleBenefit,
//         category: BENEFIT_TYPE_FEMALE,
//       }))) ||
//     [];
//   return [...planCoverages, ...hospitalizationBenefits, ...femaleBenefits];
// };

// const formatAllBenefitsPayload = (allBenefits) => {
//   const planCoverages = [];
//   const hospitalizationBenefits = [];
//   const femaleBenefits = [];
//   allBenefits.forEach((benefit) => {
//     if (benefit.category === BENEFIT_TYPE_PLAN_COVERAGE) {
//       planCoverages.push(benefit);
//     } else if (benefit.category === BENEFIT_TYPE_HOSPITALIZATION) {
//       hospitalizationBenefits.push(benefit);
//     } else if (benefit.category === BENEFIT_TYPE_FEMALE) {
//       femaleBenefits.push(benefit);
//     }
//   });
//   return {
//     planCoverages,
//     hospitalizationBenefits,
//     femaleBenefits,
//   };
// };

// const formatPolicyDetails = (policyDetails) => {
//   return {
//     ...policyDetails,
//     insuranceCompany: policyDetails.company,
//     medicalCard: policyDetails.medicalCard
//       ? {
//           ...policyDetails.medicalCard,
//           lifetimeLimitAmt:
//             policyDetails.medicalCard.lifetimeLimitAmt > -1
//               ? policyDetails.medicalCard.lifetimeLimitAmt
//               : undefined,
//           isLifetimeLimitAmtUnlimited:
//             policyDetails.medicalCard.lifetimeLimitAmt === -1 || false,
//         }
//       : undefined,
//   };
// };

// const formatPayloadBody = (values, allBenefits) => {
//   return {
//     benefits:
//       allBenefits.length > 0
//         ? formatAllBenefitsPayload(allBenefits)
//         : undefined,
//     medicalCard: values.medicalCard
//       ? {
//           ...values.medicalCard,
//           lifetimeLimitAmt: values.medicalCard.isLifetimeLimitAmtUnlimited
//             ? -1
//             : values.medicalCard.lifetimeLimitAmt,
//           isLifetimeLimitAmtUnlimited: undefined,
//         }
//       : undefined,
//   };
// };

// const constructCoveragesAndBenefitsTableColumns = (benefitTypes) => [
//   {
//     dataIndex: "type",
//     key: "type",
//     render: (value, record) => (
//       <div>
//         <Label>
//           {getLabelOfConstant(value, benefitTypes) || "-"}
//           {record.label ? ` - ${record.label}` : ""}
//         </Label>
//         <DescriptionForLabel>{record.desc}</DescriptionForLabel>
//       </div>
//     ),
//   },
//   {
//     dataIndex: "amount",
//     key: "amount",
//     render: (value) =>
//       value ? (
//         <FinancialValueText>
//           {constructDisplayPrice(value, false)}
//         </FinancialValueText>
//       ) : (
//         <FinancialValueText>Yes</FinancialValueText>
//       ),
//   },
//   {
//     dataIndex: "remarks",
//     key: "remarks",
//     render: (value) => <ExtraInfoText>{value}</ExtraInfoText>,
//   },
// ];

// const Policy = () => {
//   console.log(useParams());
//   console.log(useParams().id);

//   const { id: policyId } = useParams();
//   const history = useHistory();
//   const [form] = useForm();
//   const {
//     isLoading: isPolicyDetailsLoading,
//     data: policyDetails,
//   } = useGetPolicyDetails(policyId);
//   const {
//     isLoading: isPlanTypesLoading,
//     selection: planTypes,
//   } = useFetchConstant("planTypes");
//   const {
//     isLoading: isInsuranceCompaniesLoading,
//     selection: insuranceCompanies,
//     data: insuranceCompaniesConst,
//   } = useFetchConstant("insuranceCompanies");
//   const {
//     isLoading: isBenefitTypesLoading,
//     selection: benefitTypes,
//   } = useFetchConstant("benefitTypes");
//   const {
//     isLoading: isPaymentModesLoading,
//     selection: paymentModes,
//   } = useFetchConstant("paymentModes");
//   const isLoading =
//     isPolicyDetailsLoading ||
//     isPlanTypesLoading ||
//     isInsuranceCompaniesLoading ||
//     isBenefitTypesLoading ||
//     isPaymentModesLoading;

//   const [allBenefits, setAllBenefits] = useState([]);
//   const [
//     showCoverageAndBenefitModal,
//     setShowCoverageAndBenefitModal,
//   ] = useState(false);
//   const [
//     selectedCoverageAndBenefitIndex,
//     setSelectedCoverageAndBenefitIndex,
//   ] = useState(-1);
//   const [selectedInsuranceCompany, setSelectedInsuranceCompany] = useState("");
//   const [selectedType, setSelectedType] = useState("");
//   const [
//     shouldShowOtherCompanyInput,
//     setShouldShowOtherCompanyInput,
//   ] = useState(false);

//   const defaultValues = useMemo(() => formatPolicyDetails(policyDetails), [
//     policyDetails,
//   ]);
//   const [
//     isLifetimeLimitAmtUnlimited,
//     setIsLifetimeLimitAmtUnlimited,
//   ] = useState(false);
//   const [lifetimeLimitAmt, setLifetimeLimitAmt] = useState("");

//   useEffect(() => {
//     if (policyDetails.benefits) {
//       setAllBenefits(formatAllBenefits(policyDetails.benefits));
//     }
//     if (defaultValues.medicalCard) {
//       const isLifetimeLimitAmtUnlimitedFormValue =
//         defaultValues.medicalCard &&
//         defaultValues.medicalCard.isLifetimeLimitAmtUnlimited;
//       const lifetimeLimitAmtFormValue =
//         defaultValues.medicalCard && defaultValues.medicalCard.lifetimeLimitAmt;
//       setIsLifetimeLimitAmtUnlimited(isLifetimeLimitAmtUnlimitedFormValue);
//       setLifetimeLimitAmt(lifetimeLimitAmtFormValue);
//     }
//     if (defaultValues.company) {
//       setSelectedInsuranceCompany(defaultValues.company.type);
//     }
//     if (defaultValues.type) {
//       setSelectedType(defaultValues.type);
//     }
//   }, [policyDetails, defaultValues]);

//   useEffect(() => {
//     if (
//       !isInsuranceCompaniesLoading &&
//       selectedInsuranceCompany === insuranceCompaniesConst.OTHERS.code
//     ) {
//       setShouldShowOtherCompanyInput(true);
//     } else {
//       setShouldShowOtherCompanyInput(false);
//     }
//   }, [
//     insuranceCompaniesConst,
//     selectedInsuranceCompany,
//     isInsuranceCompaniesLoading,
//   ]);

//   const isNew = !policyId && !Object.keys(policyDetails).length > 0;

//   const handleOnCoverageAndBenefitRowSelect = (index) => {
//     setSelectedCoverageAndBenefitIndex(index);
//     setShowCoverageAndBenefitModal(true);
//   };

//   const handleOnAddCoverageBenefitModalOkButtonClick = (values) => {
//     if (selectedCoverageAndBenefitIndex > -1) {
//       let editedBenefits = [...allBenefits];
//       editedBenefits[selectedCoverageAndBenefitIndex] = values;
//       setAllBenefits(editedBenefits);
//       setSelectedCoverageAndBenefitIndex(-1);
//     } else {
//       const newBenefits = [...allBenefits, values];
//       setAllBenefits(newBenefits);
//     }
//     setShowCoverageAndBenefitModal(false);
//   };

//   const handleOnAddCoverageBenefitModalRemoveButtonClick = () => {
//     const newBenefits = [...allBenefits];
//     newBenefits.splice(selectedCoverageAndBenefitIndex, 1);
//     setAllBenefits(newBenefits);
//     setShowCoverageAndBenefitModal(false);
//   };

//   const handleOnAddCoverageBenefitModalCancelButtonClick = () => {
//     setSelectedCoverageAndBenefitIndex(-1);
//     setShowCoverageAndBenefitModal(false);
//   };

//   const handleOnSaveButtonClick = async (e) => {
//     e.preventDefault();
//     try {
//       const values = await form.validateFields();
//       const payload = {
//         ...values,
//         ...formatPayloadBody(values, allBenefits),
//       };
//       if (!isNew) {
//         patchPolicy(policyId, payload)
//           .then((res) => {
//             refetchPolicies();
//             refetchPolicyDetails(policyId);
//             message.success("Update success!");
//           })
//           .catch((ex) => {
//             message.error(
//               "Error in updating policy details. Please check your connection and try again."
//             );
//           });
//       } else {
//         postCreatePolicy(payload)
//           .then((res) => {
//             refetchPolicies();
//             refetchPolicyDetails(res._id);
//             success({
//               title: "Policy has been added!",
//               okText: "Back to View All",
//               onOk() {
//                 history.push(buildPoliciesUri());
//               },
//             });
//           })
//           .catch((ex) => {
//             error({
//               title: "Unable to create this policy.",
//             });
//           });
//       }
//     } catch (error) {
//       error.errorFields.forEach((field) => message.error(field.errors[0]));
//     }
//   };

//   const handleOnDeleteButtonClick = () => {
//     confirm({
//       title: "Do you want to remove this policy?",
//       okText: "Yes",
//       onOk() {
//         deletePolicy(policyId)
//           .then((res) => {
//             message.success("Policy deleted!");
//             refetchPolicies();
//             history.push(buildPoliciesUri());
//           })
//           .catch((ex) => {
//             message.error(
//               "Error in deleting policy. Please check your connection and try again."
//             );
//           });
//       },
//       onCancel() {},
//     });
//   };

//   return (
//     <>
//       <Row justify="space-between" align="middle">
//         <ClickableTextButton
//           text="Back to View All"
//           onClick={() => history.push(buildPoliciesUri())}
//           type="back"
//           showIcon={true}
//         />
//         <Row align="middle">
//           {!isNew && (
//             <DeleteCol>
//               <ClickableTextButton
//                 text="Delete"
//                 onClick={handleOnDeleteButtonClick}
//               />
//             </DeleteCol>
//           )}
//           <Col span={12}>
//             <Button
//               type="primary"
//               icon={<CheckOutlined />}
//               onClick={handleOnSaveButtonClick}
//             >
//               Save
//             </Button>
//           </Col>
//         </Row>
//       </Row>
//       {isLoading ? (
//         <Skeleton active />
//       ) : (
//         <ScrollableContainer>
//           <Form form={form} initialValues={defaultValues}>
//             <Title marginBottom="16px">
//               {isNew ? "New Policy" : policyDetails.name}
//             </Title>
//             <SectionContainer>
//               <SectionCard title="Plan Description">
//                 <Row gutter={16}>
//                   <Col span={shouldShowOtherCompanyInput ? 24 : 12}>
//                     <FormInput
//                       label="Name"
//                       name="name"
//                       placeholder="Enter policy name"
//                       requiredErrorMessage="Please enter policy name."
//                     />
//                   </Col>
//                   <Col span={12}>
//                     <FormSelection
//                       label="Insurance Company"
//                       name={["company", "type"]}
//                       placeholder="Select policy company"
//                       requiredErrorMessage="Please select company of this policy."
//                       selections={insuranceCompanies}
//                       onChange={setSelectedInsuranceCompany}
//                     />
//                   </Col>
//                   {shouldShowOtherCompanyInput && (
//                     <Col span={12}>
//                       <FormInput
//                         label={<div style={{ height: 25 }}> </div>}
//                         name={["company", "label"]}
//                         placeholder="Please specify the name of the company"
//                         requiredErrorMessage="Please enter the name of the insurance company."
//                       />
//                     </Col>
//                   )}
//                   <Col span={12}>
//                     <FormSelection
//                       label="Type of Plan"
//                       name="type"
//                       placeholder="Select type of policy"
//                       requiredErrorMessage="Please select the type of this policy."
//                       selections={planTypes}
//                       onChange={setSelectedType}
//                     />
//                   </Col>
//                   {selectedType === "otherPlanType" && (
//                     <Col span={12}>
//                       <FormInput
//                         label={<div style={{ height: 25 }}> </div>}
//                         name="otherTypeLabel"
//                         placeholder="Please specify the policy type"
//                         requiredErrorMessage="Please enter label for this policy type."
//                       />
//                     </Col>
//                   )}
//                   <Col span={12}>
//                     <FormInput
//                       label="Premium"
//                       name="premium"
//                       placeholder="0.00"
//                       type="financial"
//                       requiredErrorMessage="Please enter premium of this policy."
//                     />
//                   </Col>
//                   <Col span={12}>
//                     <FormSelection
//                       label="Mode of Payment"
//                       name="paymentMode"
//                       placeholder="Select mode of payment"
//                       requiredErrorMessage="Please select mode of payment."
//                       selections={paymentModes}
//                     />
//                   </Col>
//                 </Row>
//               </SectionCard>
//             </SectionContainer>
//             <SectionContainer>
//               <SectionCard title="Medical Card Details">
//                 <Row gutter={16}>
//                   <Col span={12}>
//                     <FormInput
//                       label="Name"
//                       name={["medicalCard", "name"]}
//                       placeholder="Enter medical card's name"
//                     />
//                   </Col>
//                   <Col span={12}>
//                     <FormInput
//                       label="Room And Board"
//                       name={["medicalCard", "roomAndBoardAmt"]}
//                       placeholder="0.00"
//                       type="financial"
//                     />
//                   </Col>
//                   <Col span={12}>
//                     <FormInput
//                       label="Yearly Limit"
//                       name={["medicalCard", "yearlyLimitAmt"]}
//                       placeholder="0.00"
//                       type="financial"
//                     />
//                   </Col>
//                   <Col span={12}>
//                     <FormInput
//                       disabled={!!isLifetimeLimitAmtUnlimited}
//                       label="Lifetime Limit"
//                       name={["medicalCard", "lifetimeLimitAmt"]}
//                       placeholder="0.00"
//                       type="financial"
//                       // requiredErrorMessage={!isLifetimeLimitAmtUnlimited && !lifetimeLimitAmt && 'Please enter lifetime limit of this medical card.'}
//                       extraProps={{
//                         onChange: (e) => setLifetimeLimitAmt(e.target.value),
//                       }}
//                     />
//                     <FormItem
//                       name={["medicalCard", "isLifetimeLimitAmtUnlimited"]}
//                       valuePropName="checked"
//                       style={{ marginTop: "-16px" }}
//                     >
//                       <Checkbox
//                         disabled={!!lifetimeLimitAmt}
//                         onClick={(e) => {
//                           setIsLifetimeLimitAmtUnlimited(e.target.checked);
//                         }}
//                       >
//                         Unlimited for lifetime
//                       </Checkbox>
//                     </FormItem>
//                   </Col>
//                   <Col span={12}>
//                     <FormInput
//                       label="Outpatient Cancer Treatment"
//                       name={["medicalCard", "outpatientCancerTreatmentAmt"]}
//                       placeholder="0.00"
//                       type="financial"
//                     />
//                   </Col>
//                   <Col span={12}>
//                     <FormInput
//                       label="Outpatient Kidney Dialysis Treatment"
//                       name={[
//                         "medicalCard",
//                         "outpatientKidneyDialysisTreatmentAmt",
//                       ]}
//                       placeholder="0.00"
//                       type="financial"
//                     />
//                   </Col>
//                 </Row>
//               </SectionCard>
//             </SectionContainer>
//             <SectionContainer>
//               <SectionCard
//                 loading={isLoading}
//                 title="Coverages and Benefits"
//                 buttonText="Add Coverage/Benefit"
//                 onActionButtonClick={() => setShowCoverageAndBenefitModal(true)}
//               >
//                 <Row gutter={16}>
//                   <Table
//                     dataSource={allBenefits}
//                     columns={constructCoveragesAndBenefitsTableColumns(
//                       benefitTypes
//                     )}
//                     pagination={false}
//                     rowKey={(record, index) => index}
//                     showHeader={false}
//                     style={{ width: "100%" }}
//                     onRow={(record, index) => {
//                       return {
//                         onClick: () =>
//                           handleOnCoverageAndBenefitRowSelect(index),
//                       };
//                     }}
//                   />
//                 </Row>
//               </SectionCard>
//             </SectionContainer>
//             {showCoverageAndBenefitModal && (
//               <AddCoverageBenefitModal
//                 defaultValues={
//                   selectedCoverageAndBenefitIndex > -1 &&
//                   allBenefits[selectedCoverageAndBenefitIndex]
//                 }
//                 isLoading={isLoading}
//                 onOk={handleOnAddCoverageBenefitModalOkButtonClick}
//                 onClose={handleOnAddCoverageBenefitModalCancelButtonClick}
//                 onRemove={handleOnAddCoverageBenefitModalRemoveButtonClick}
//                 benefitTypes={benefitTypes}
//                 visible={showCoverageAndBenefitModal}
//               />
//             )}
//           </Form>
//         </ScrollableContainer>
//       )}
//     </>
//   );
// };

// export default Policy;
